<template>
    <div class="FM_withdrawalInfo">
        <!-- 添加处罚信息 -->
        <el-dialog
                ref="terminalAudit"
                :visible="examineShow"
                @close="handleClose"
                :close-on-click-modal="false"
        >
            <el-card class="box-card" shadow="hover">
                <div class="title">投诉人信息</div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <span class="labels">投诉人：</span>
                        <span>{{dialogData.data.merchant_detail}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">被投诉人：</span>
                        <span>{{dialogData.data.user_detail}}</span>
                    </el-col>
                    <el-col :span="24" v-if="litigation_id">
                        <span class="labels">第{{dialogData.data.number_of_times}}投诉</span>
                    </el-col>
                </el-row>
                <el-form
                        label-position="top"
                        label-width="80px"
                >
                    <div class="title">备注</div>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <span class="labels">确认信息：</span>
                            <span>若与商户协调好,请提交信息。</span>
                        </el-col>
                    </el-row>
                    <tinymce v-model="auditForm.content" ref="editor" @getVal="getVal" />
                </el-form>
                <div style="margin-top:60px">
                    <el-button
                            @click="submit"
                            type="primary"
                            size="medium"
                            style="font-size:12px"
                            :loading="loading"
                    >提 交</el-button>
                </div>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
import tinymce from '../../components/Editor/Editor2'
export default {
    name: "merchant-examine",
    props: {
        examineShow: {
            type: Boolean,
            default: false
        },
        dialogData: {
            type: Object
        },
    },
    data() {
        return {
            auditForm: {
                content: '', // 处罚详情
                litigation_id:this.dialogData.data.litigation_id, //投诉id
                num:this.dialogData.data.num,
            },
            loading: false,
            checked: true,
            activeName: '',
            litigation_id:this.dialogData.data.litigation_id,
        }
    },
    mounted() {
    },
    methods: {
        // 提交处罚数据
        submit() { //提交
            this.$api.post('merchant/addExamine', this.auditForm, res => {
                if (res.code == 0) {
                    let that = this;
                    this.$message.success({
                        type: 'success',
                        message: res.msg,
                        duration: 2000,
                        onClose() {
                            that.handleClose(1);
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                    this.loading = false;
                }
            });
        },
        getVal(val) {
            this.auditForm.content = val;
        },
        // 提交处罚数据
        handleClose(ref) {
            this.$emit('infoClose', ref);
        }
    },
    components: {
        tinymce
    },
};
</script>

<style lang="scss" scope>
.FM_withdrawalInfo {
  * {
    font-size: 12px;
  }
  .labels {
    font-weight: 700;
  }
  .desc {
    border: 1px solid #d0d0d0;
    background-color: #ebeef5;
    padding: 3px;
    line-height: 20px;
    margin-top: 5px;
  }
  .title {
    margin: 10px 0;
    font-size: 13px;
    font-weight: 700;
    border-left: 5px solid #40b8ff;
    padding: 0 0 0 10px;
    .el-button--text {
      color: #303133;
      font-size: 13px;
      font-weight: 700;
    }
  }
  .el-input__inner,
  .el-row {
    margin: 10px 0;
    &:last-child {
      margin-bottom: 0;
    }
    .el-col {
      margin: 10px 0;
    }
  }
}
</style>
